import React from 'react';
import { Typography } from '@mui/material';
import News from '../components/News';

/**
 * News management reuses the existing News component, which already renders
 * add/edit/delete controls for authenticated admins. This keeps a single
 * source of truth for the news UI while surfacing it inside the admin panel.
 */
const AdminNews = () => (
    <>
        <Typography variant="h4" gutterBottom>
            Aktualności
        </Typography>
        <News manageMode />
    </>
);

export default AdminNews;
